import axios from "../../utils/axiosInstance";

export const untrustedModuleLoadsExist = async (zenGroupId, agentId, uniqueProcessIdentifier) => {
    const response = await axios.post("/untrustedModuleLoadsExist", {
        zenGroupId: zenGroupId,
        agentId: agentId,
        uniqueProcessIdentifier: uniqueProcessIdentifier
    });
    return response.data;
};

export const dllRelatedProcessesExists = async (zenGroupId, agentId, uniqueProcessIdentifier) => {
    const response = await axios.post("/dllRelatedProcessesExists", {
        zenGroupId: zenGroupId,
        agentId: agentId,
        uniqueProcessIdentifier: uniqueProcessIdentifier
    });
    return response.data;
};

export const ccUntrustedModuleLoadsListReactive = async (count, pageCount, filters, multiConditionFilters, sortModel, showAllTelemetry) => {
    const response = await axios.post("/ccUntrustedModuleLoadsListReactive", {
        page: pageCount,
        count: count,
        filters: filters,
        multiConditionFilters: multiConditionFilters,
        sortModel: sortModel,
        showAllTelemetry: showAllTelemetry
    });
    return response.data;
};
